<template>
  <div class="preArchiveSeries table-hook fadeInRight">
    <div class="title-box">
      <span class="m-title">预存系列</span>
      <el-form
        inline
        class="hook right themed-form search-form"
        style="line-height: 40px"
        :model="queryForm"
      >
        <el-form-item label="名称:">
          <el-input 
            v-model="queryForm.seriesName" 
            placeholder="请输入名称"
            @input="handleSearchNameInput"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="themed-button"
            @click="searchTable"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="themed-button"
            @click="addRecord"
            >新增</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="primary"
            :disabled="!multiple"
            icon="el-icon-remove"
            class="themed-button"
            @click="removeRecord"
            >删除</el-button
          >
        </el-form-item> -->
      </el-form>
    </div>
    <div class="content-box">
      <!-- <el-table
        ref="table"
        :data="tableData"
        @selection-change="handleSelectionChange"
        stripe
        border
        :max-height="maxTableHeight"
      > 
      <el-table-column type="selection" width="55" align="center" />
      -->
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :max-height="maxTableHeight"
      >
        
        <el-table-column
          label="名称"
          prop="seriesName"
          width="180px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="档位列表"
          prop=""
          width="180px"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="handleAmountList(scope.row.id)"
              >添加档位</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          width="180px"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button
              type="info"
              class="themed-button"
              @click="updateRecord(scope.row)"
              >编辑</el-button
            >
            <el-button
            type="primary"
            class="themed-button"
            @click="removeRecord(scope.row)"
            >删除</el-button
          >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[5, 10, 15, 50, 100, 1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      @close="closeAddOrEditDialog()"
    >
      <el-form
        label-position="right"
        label-width="120px"
        :model="addOrEditForm"
        ref="addOrEditForm"
        :rules="rules"
      >
        <el-form-item label="名称:" required prop="seriesName">
          <el-input
            v-model="addOrEditForm.seriesName"
            maxlength="150"
            show-word-limit
            placeholder="请输入名称"
            @input="handleSeriesNameInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            v-model="addOrEditForm.remark"
            type="textarea"
            placeholder="请输入备注"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="cancle()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  preArchiveSeriesList,
  addPreArchiveSeries,
  editPreArchiveSeries,
  deletePreArchiveSeries,
} from "@/api/networkCardBalanceManagement/preArchiveSeries.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import resize from "@/mixins/resize.js";

export default {
  name: "preArchiveSeries",
  mixins: [resize],
  data() {
    return {
      dialogTitle:"",
      ids: [],
      multiple: false,
      queryForm: {
        seriesName: "",
      },
      tableData: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      dialogVisible: false,
      addOrEditForm: {
        id: undefined,
        seriesName: "",
        remark: "",
      },
      rules: {
        seriesName: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { 
            validator: (rule, value, callback) => {
              if (value && value.includes(' ')) {
                callback(new Error('名称不能包含空格'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
      },
    };
  },
  mounted() {
    this._preArchiveSeriesList();
  },
  methods: {
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = selection && selection.length > 0;
    },
    
    submitForm() {
      this.$refs["addOrEditForm"].validate((valid) => {
        if (valid) {
          let params = {};
          if (!!this.addOrEditForm.id) {
            // 编辑
            params = {
              id: this.addOrEditForm.id,
              seriesName: this.addOrEditForm.seriesName,
              remark: this.addOrEditForm.remark,
            };
            editPreArchiveSeries(params)
              .then((res) => {
                this._preArchiveSeriesList();
                this.dialogVisible = false;
                this.resetForm();
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
              })
              .catch(() => {});
          } else {
            // 新增
            params = {
              seriesName: this.addOrEditForm.seriesName,
              remark: this.addOrEditForm.remark,
            };
            addPreArchiveSeries(params)
              .then((res) => {
                this._preArchiveSeriesList();
                this.dialogVisible = false;
                this.resetForm();
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    
    resetForm() {
      this.addOrEditForm.id = undefined;
      this.addOrEditForm.seriesName = "";
      this.addOrEditForm.remark = "";
    },
    
    searchTable() {
      this.pageNo = 1;
      this._preArchiveSeriesList();
    },
    
    addRecord() {
      this.dialogVisible = true;
      this.dialogTitle = "新增预存系列"
    },
    
    updateRecord(row) {
      this.dialogTitle = "编辑预存系列"
      this.dialogVisible = true;
      this.addOrEditForm.id = row.id;
      this.addOrEditForm.seriesName = row.seriesName;
      this.addOrEditForm.remark = row.remark;
    },
    
    closeAddOrEditDialog() {
      this.resetForm();
    },
    
    cancle() {
      this.dialogVisible = false;
      this.resetForm();
    },
    
    removeRecord(row){
      this.$confirm("确认要删除该预存系列吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除单条记录
          let params = {
            id: row.id,
          };
          deletePreArchiveSeries(params)
            .then((res) => {
              this._preArchiveSeriesList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: "删除失败",
                type: "error",
              });
            });
        })
        .catch(() => {});
    },

    // removeRecord() {
    //   if (!this.ids || this.ids.length == 0) {
    //     this.$alert("请选择数据!", "提示", {
    //       confirmButtonText: "确定",
    //     });
    //     return;
    //   }
    //   this.$confirm("确认要删除所选的数据吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       // 支持批量删除
    //       let params = {
    //         id: this.ids.join(","),
    //       };
    //       deletePreArchiveSeries(params)
    //         .then((res) => {
    //           this._preArchiveSeriesList();
    //           this.multiple = false;
    //           this.ids = [];
    //           this.$message({
    //             showClose: true,
    //             message: "删除成功",
    //             type: "success",
    //           });
    //         })
    //         .catch(() => {
    //           this.multiple = false;
    //           this.ids = [];
    //           this.$message({
    //             showClose: true,
    //             message: "删除失败",
    //             type: "error",
    //           });
    //         });
    //     })
    //     .catch(() => {});
    // },
    
    handleSizeChange(val) {
      this.pageSize = val;
      this._preArchiveSeriesList();
    },
    
    handleCurrentChange(val) {
      this.pageNo = val;
      this._preArchiveSeriesList();
    },
    
    _preArchiveSeriesList() {
      let params = Object.assign(this.queryForm, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      preArchiveSeriesList(params).then((res) => {
        this.pageNo = res.pageNo;
        this.pageSize = res.pageSize;
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    
    handleAmountList(seriesId) {
      // 跳转到档位列表界面
      this.$router
        .push({ path: "/preArchiveSeries/amountList/" + seriesId })
        .catch(() => true);
    },
    
    handleSeriesNameInput(value) {
      // 移除输入中的空格
      if (value && value.includes(' ')) {
        this.addOrEditForm.seriesName = value.replace(/\s/g, '');
      }
    },
    
    handleSearchNameInput(value) {
      // 移除搜索框输入中的空格
      if (value && value.includes(' ')) {
        this.queryForm.seriesName = value.replace(/\s/g, '');
      }
    },
    
   
  },
};
</script>

<style scoped>
.preArchiveSeries {
  padding: 20px;
}

.title-box {
  margin-bottom: 20px;
}

.content-box {
  margin-bottom: 20px;
}

.pagination {
  text-align: center;
}
</style>
